import React from "react";
import logo from "../assets/images/DENT_LOGO.png";
import "../commons/BackColor.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const back = (e) => {
  e.preventDefault();
  window.history.back();
};

const BarraSupDent = () => (
  <React.Fragment>
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="text-center mx-auto">
        <span id="btnBack" className="iconSupBack">
          <a className="navbar-brand colorIcon" href="/" onClick={back}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </a>
        </span>
        <span className="iconSup mx-auto">
          <img
            src={logo}
            alt="logo"
            width="15%"
            className="imgSizeLogo mx-auto"
          />
        </span>
      </div>
    </nav>
  </React.Fragment>
);
export default BarraSupDent;
